"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteredChatContext = void 0;
const react_1 = require("react");
exports.FilteredChatContext = (0, react_1.createContext)({});
